export const LANDING_ROUTES = {
  welcome: '/',
  getApp: '/charging',
};

export const LANDING_ROUTES_PATHS = Object.values(LANDING_ROUTES);
